import { Vue } from 'vue-property-decorator';
import i18n from '../i18n';

let instance: LanguageService = null;
const vue = new Vue({ i18n });

export default class LanguageService {
    constructor() {
        if (!instance) {
            instance = this;
        }

        this.setLanguage(this.language);

        return instance;
    }

    get language() {
        return window.localStorage.getItem('language') || 'en';
    }

    set language(language: string) {
        this.setLanguage(language);
    }

    protected setLanguage(language: string) {
        window.localStorage.setItem('language', language);
        vue.$i18n.locale = language;
    }
}
